import { Button } from "../ui/button";

interface MapTileStatusProps {
  isLoading: boolean;
  failedTileCount: number;
  onRetry: () => void;
}

export function MapTileStatus({ isLoading, failedTileCount, onRetry }: MapTileStatusProps) {
  if (!isLoading && failedTileCount === 0) return null;

  return (
    <div
      className="absolute right-2 top-2 z-[1000] max-w-[calc(100%-1rem)] rounded-md border border-border bg-background/95 p-2 text-xs shadow-md sm:text-sm"
      role="status"
      aria-live="polite"
    >
      {failedTileCount > 0 ? (
        <div className="flex flex-wrap items-center gap-2">
          <span>
            {failedTileCount === 1
              ? "Une tuile n'a pas pu être chargée."
              : `${failedTileCount} tuiles n'ont pas pu être chargées.`}
          </span>
          <Button type="button" size="sm" variant="outline" onClick={onRetry}>
            Recharger
          </Button>
        </div>
      ) : (
        <span>Chargement de la carte...</span>
      )}
    </div>
  );
}
